const NasirNasrullah = () => {
    return(
    <div>
        <div className="bg-[#fcfcfc] pt-[2rem]">
            <div className="sm:max-w-[70rem] mx-auto sm:px-[10rem] lg:flex grid  lg:justify-between items-end">
                <div className="mb-[2.5rem] lg:grid hidden">
                    <h1 className="text-[30px] font-bold">Brig (Retd) Nasir Nasrullah</h1>
                    <p>Director Risk & Security</p>
                </div>
                <div className="flex justify-end">
                    <img src="/leadershipnew/brig-(retd.)-nasir-nasrullah.jpg" alt="" className="sm:h-[26rem] h-[17rem] leadership-images" />
                 </div>
                <div className="mb-[2.5rem] mx-[2rem]  lg:hidden grid justify-left mt-[.7rem]">
                    <h1 className="sm:text-[30px] text-[26px] font-bold">Brig (R) Nasir Nasrullah</h1>
                    <p>Director Risk & Security</p>
                </div>
            </div>
        </div>
        {/* <div className="max-w-[40rem] mx-auto my-[4rem] flex flex-col justify-center items-center text-left gap-6">
          <p>
          Muneeza is a seasoned finance resource with 23 plus years of experience with Shell & Engro working 
          in Pakistan and UAE in various global regional & local roles within the finance organization in 
          diverse industries like Oil & Gas, Petrochemical, and Terminal Infrastructure. She brings valuable 
          experience in overall governance, financial controls, transformation and has strong business acumen. 
          Her leadership is based on the care and growth of people. In her last assignment Muneeza was heading 
          Finance Optimization for Engro Corporation and prior to that was CFO for Engro Vopak Terminal Limited.
          </p>
          
        </div> */}
    </div>
    );
};
export default NasirNasrullah;